export default "__VITE_ASSET__COTs2aKa__"